import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import GuestCheckoutVerificationDataGrid from './guest-checkout-verification-data-grid/guest-checkout-verification-data-grid.component';
import GuestCheckoutVerificationSummaryHeader from './guest-checkout-verification-summary-header/guest-checkout-verification-summary-header.component';
import ExportButton from '../../export-button/export-button.component';
import { useTranslation } from 'react-i18next';
import { useLazyExportGuestCheckoutVerificationsReportQuery } from 'api/sms-reports-service/sms-reports-service';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useSearchParamsContext } from 'components/search/search.hooks';
import { getClientAlias } from 'util/client-alias';
import IncPageBody from 'components/inc-page/inc-page-body/inc-page-body.component';
import { DateTime } from 'luxon';
import { useSMSTotalsSearch } from '../../sms-reports-landing/sms-reports-search/sms-reports-search.hooks';
import { useHasAccessToAssignedLocations } from 'hooks/access-component.hooks';
import { downloadCSV } from 'util/download-csv.utils';
import { Box } from '@mui/material';

const GuestCheckoutVerification = () => {
  const { t } = useTranslation();

  const { enqueueSnackbar } = useSnackbar();
  const [isExporting, setIsExporting] = useState(false);

  const isGuestCheckoutVerificationSummaryHeaderVisible =
    useHasAccessToAssignedLocations();

  const { refetchSMSTotals } = useSMSTotalsSearch(
    'GUEST_CHECKOUT_VERIFICATION',
  );

  const { searchParams } = useSearchParamsContext();
  const [exportGuestCheckoutVerificationQuery] =
    useLazyExportGuestCheckoutVerificationsReportQuery();

  const exportReportFunction = async () => {
    setIsExporting(true);
    try {
      const { data: csvData } = await exportGuestCheckoutVerificationQuery({
        startDate: searchParams.startDate.value,
        endDate: searchParams.endDate.value,
        storeIds: searchParams.storeIds.value,
      });

      downloadCSV(
        csvData,
        `${getClientAlias()}_Guest_Checkout_Verification_SMS_${DateTime.local().toFormat(
          'yyyy_MM_dd__HH_mm_ss',
        )}`,
      );
      enqueueSnackbar(
        t(
          'page.reportAndAnalytics.smsReports.sections.guestCheckoutVerification.toast.success',
        ),
        { severity: 'success' },
      );
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <IncPageBody>
      <SearchToolbar
        buttons={
          <ExportButton
            exportReportFunction={exportReportFunction}
            isAdditionalLoading={isExporting}
          />
        }
        onRefreshClick={refetchSMSTotals}
      />
      <Box mt={2}>
        {isGuestCheckoutVerificationSummaryHeaderVisible && (
          <GuestCheckoutVerificationSummaryHeader />
        )}
        <GuestCheckoutVerificationDataGrid />
      </Box>
    </IncPageBody>
  );
};

export default GuestCheckoutVerification;
